import { COLORS } from '@elo-kit/constants/general.constants'

// TODO: update with using createUseStyles
const quizAttemptStyles = (theme) => ({
  attemptInfo: {
    color: `${theme.notificationsColor || COLORS.eloOrange} !important`,
    '& i': {
      color: `${theme.notificationsColor || COLORS.eloOrange} !important`,
    },
  },
  attemptStatus: {
    fontSize: '18px !important',
    fontFamily: 'Montserrat Medium !important',
    fontStyle: 'normal !important',
    marginLeft: '7px',
    marginRight: '30px',
    color: `${theme.notificationsColor || COLORS.eloOrange} !important`,
  },
})

export default quizAttemptStyles
